<script>
import moment from 'moment';
import Vue from 'vue';
export default {
  props: {
    inputValue: {
      type: String,
      default: '',
    },
    constValue: {
      type: String,
      default: '',
    },
    inputID: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    errorMassage: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    isMax: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      isDatePickerOpen: false,
      dateValue: '',
    };
  },
  methods: {
    closeDatePicker() {
      this.isDatePickerOpen = false;
    },
    showDatePicker() {
      this.isDatePickerOpen = true;
    },
    resetDateValue(e) {
      e.stopPropagation();
      e.preventDefault();
      this.dateValue = '';
    },
  },
  computed: {
    maxDateTime() {
      return moment().format('YYYY-MM-DDTHH:mm:ss');
    },
    displayDate: function () {
      if (this.dateValue) return Vue.moment(this.dateValue).format('jYYYY-jMM-jDDTHH:mm:ss');
      else if (this.constValue)
        return Vue.moment(this.constValue).format('HH:mm:ss jYYYY-jMM-jDD');
      return '';
    },
  },
  mounted() {
    this.dateValue = this.constValue;
  },
  watch: {
    dateValue: function (currentVal) {
      this.$emit('input', currentVal);
    },
  },
};
</script>
<template>
  <div>
    <div>
      <v-text-field outlined :dense="dense" :hide-details="!!!errorMassage" :id="inputID" :value="displayDate"
        type="text" @click:clear="resetDateValue" clearable :label="label" :disabled="disabled"
        :error-messages="errorMassage" prepend-inner-icon="mdi-calendar-range mdi-18px"
        :class="{ 'date-picker-input': !dense }">
        <template v-if="!disabled" slot="append">
          <div @click="showDatePicker" :class="{ 'btn-container-normal': !dense }">
            <v-icon class="calender-background ml-n3 calender-background"
              :class="{ 'mt-n2': dense, 'height-full': !dense }" color="white">
              mdi-calendar-range mdi-18px
            </v-icon>
          </div>
        </template>
      </v-text-field>
    </div>
    <date-picker v-model="dateValue" simple type="datetime" display-date="jYYYY-jMM-jDDTHH:mm:ss"
      format="YYYY-MM-DDTHH:mm:ss" :custom-input="`#${inputID}`" :max="isMax && (maxDateTime || undefined)" />
  </div>
</template>
<style lang="scss">
.btn-container {
  &-normal {
    height: 56px;
  }

  & {
    .calender-background {
      height: 100%;
      background: var(--);
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 12px;
      padding-bottom: 12px;
      border-top-left-radius: 5px !important;
      border-bottom-left-radius: 5px !important;
    }
  }
}

.date-picker-input {
  .v-input__append-inner {
    margin-top: 0 !important;
  }
}
</style>
